import React from 'react';
import classnames from 'classnames';
import { Tooltip } from 'antd';
import style from './quickSetting.module.scss';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import { apiHolder, apis } from 'api';
import { getIn18Text } from 'api';
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const QuickSettingButton = (props) => {
    const { isMini, onDrawerOpen } = props || {};
    const [visible, setVisible] = useState2RM('configMailShow', 'doUpdateConfigMailShow');
    const openDrawer = () => {
        setVisible(true);
        onDrawerOpen && onDrawerOpen();
        trackApi.track('pcMail_click_quickSet_mailListPage', { layout: isMini ? '左右分栏' : '通栏' });
    };
    return (React.createElement("span", { onClick: openDrawer, "data-test-id": "mail-list-tab-config-btn", style: { fontSize: '12px', display: 'flex', alignItems: 'center' } },
        isMini ? (React.createElement(Tooltip, { title: getIn18Text('YOUXIANGSHEZHI'), autoAdjustOverflow: true },
            React.createElement("i", { className: classnames(style.itemIcon, style.setting) }))) : (React.createElement("i", { className: classnames(style.itemIcon, style.setting) })),
        !isMini && React.createElement("span", { style: { marginLeft: '4px', minWidth: 50 } }, getIn18Text('YOUXIANGSHEZHI'))));
};
export default QuickSettingButton;
